import { useEffect } from 'react';

import WebApp from '@twa-dev/sdk';

import { useAppActions } from '@/shared/store/app-store/app-store';
import { ThemeMode } from '@/shared/store/app-store/types';
import { useTgActions } from '@/shared/store/tg-store/tg-store';

export const useTelegramTheme = () => {
  const { setTheme } = useAppActions();
  const { hydrate } = useTgActions();

  useEffect(() => {
    const handleTelegramTheme = () => {
      setTheme((WebApp?.colorScheme as ThemeMode) ?? ThemeMode.DARK);
    };

    const handleTelegramIsFullscreen = () => {
      hydrate({ isFullscreen: !!WebApp.isFullscreen });
    };

    handleTelegramTheme();
    handleTelegramIsFullscreen();

    WebApp.onEvent('fullscreenChanged', handleTelegramIsFullscreen);
    WebApp.onEvent('themeChanged', handleTelegramTheme);

    return () => {
      WebApp.offEvent('themeChanged', handleTelegramTheme);
      WebApp.offEvent('fullscreenChanged', handleTelegramIsFullscreen);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
